module.exports = __webpack_public_path__ + "img/Congrats_Page_step_01.acc6d5b0.jpg";